import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IStatusGroup } from 'src/app/modules/widget/interfaces/status-group';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { msToHms } from 'projects/common/src/app/services/utils/utilities';

@Component({
  selector: 'app-status-modal',
  templateUrl: './status-modal.component.html',
  styleUrls: ['./status-modal.component.scss']
})
export class StatusModalComponent {


  @Input()
  public selectedStatus: string;

  @Input()
  public set allStatus(allStatus: IStatusGroup[][]) {

    if (!this.availableStatus) {
      this.availableStatus = [];
    }

    for (const statusGroup of allStatus) {
      for (const status of statusGroup) {
        this.availableStatus.push(status);
      }
    }

    if (this.selectedStatus) {
      this.statusShowing = this.availableStatus.filter((value) => value.parentStatusName === this.selectedStatus);
      this.allShowing = Object.assign([], this.statusShowing);
    }

    if (!this.statusToSelect) {
      this.statusToSelect = [];
    }

    this.statusToSelect = this.availableStatus.map((value) => value.parentStatusName);
    this.statusToSelect = this.statusToSelect.filter((v, i) => this.statusToSelect.indexOf(v) === i);
    this.totalRegister = Object.assign([], this.statusShowing);

    this.completeStatusField();
    this.changeTime();
    this.paginate(1);
  }

  @Input()
  public machineName: string;

  @Input()
  public totalTime: number;

  public availableStatus: IStatusGroup[];
  public statusShowing: IStatusGroup[];
  public allShowing: IStatusGroup[];
  public statusToSelect: string[];
  public machineType: string;
  public textTime: string;
  public page: number;
  public totalRegister: any;
  public totalPages: number;

  constructor(
    public activeModal: NgbActiveModal,
    private parameterService: ParameterHandlerService
  ) {
    this.machineType = (this.parameterService.parameters.item('machine-context').value as IMachineContext).name || '';
    this.page = 1;
  }

  /**
   * Function to change the status to load
   */
  public changeStatus(event: any): void {
    const status = event.target.value;
    this.statusShowing = [];

    setTimeout(() => {
      if (status === 'all') {
        this.statusShowing = this.availableStatus;
      } else {
        this.statusShowing = this.availableStatus.filter((value) => value.parentStatusName.toLowerCase() === status.toLowerCase());
      }
      this.allShowing = Object.assign([], this.statusShowing);
      this.totalRegister = Object.assign([], this.statusShowing);
      this.changeTime();
      this.paginate(1);
    }, 0);
  }


  /**
   * Function to complete fields for status
   */
  private completeStatusField(): void {
    this.availableStatus.forEach((status) => {
      status.hours = msToHms(status.milliseconds);
      status.percentage = Number(Number((Number(status.milliseconds) * 100) / Number(status.totalDifference)).toFixed(2));
    });
  }

  /**
   * Function to set the new text field
   */
  private changeTime(): void {
    let totalMilliseconds = 0;
    let totalPercentage = 0;
    this.statusShowing.forEach((status) => totalMilliseconds = Number(totalMilliseconds) + Number(status.milliseconds));
    this.statusShowing.forEach((status) => totalPercentage = Number(totalPercentage) + Number(status.percentage));

    this.textTime = `${msToHms(totalMilliseconds)} hrs de ${this.totalTime} hrs`;
    this.textTime += ` (${totalPercentage.toFixed(2) === '99.99' ? '100' : totalPercentage.toFixed(2)}%)`;
  }


  /**
   * Function to paginate table
   * @param page Current page
   */
  private paginate(page: number): void {
    if (this.allShowing.length > 6) {
      const since = (6 * (page - 1));

      const newShow = [];
      for (let i = since; i < (since + 6); i ++) {
        if (this.allShowing[i]) {
          newShow.push(this.allShowing[i]);
        }
      }

      this.statusShowing = newShow;
    }

    this.page = page;
    this.totalPages = Math.ceil(Number(this.totalRegister.length / 6));
  }

}
